export const zIndices = {
  header: 1000,
}
